// Chrome, actions, units, the practice/AI notices and the shortcut overlay —
// the copy every screen shares.
export const common = {
  // ── app ──────────────────────────────────────────────────────────────
  'app.title': 'Parsina — Student & Resident Panel',

  // ── common ───────────────────────────────────────────────────────────
  'common.actions.cancel': 'Cancel',
  'common.actions.retry': 'Try again',
  'common.actions.save': 'Save',
  'common.actions.saving': 'Saving…',
  'common.actions.back': 'Back',
  'common.actions.add': 'Add',
  'common.actions.edit': 'Edit',
  'common.actions.delete': 'Delete',
  'common.actions.close': 'Close',
  'common.actions.confirm': 'Confirm',
  'common.actions.create': 'Create',
  'common.actions.open': 'Open',
  'common.actions.clear': 'Clear',
  'common.actions.copy': 'Copy',
  'common.actions.copied': 'Copied',
  'common.actions.rename': 'Rename',
  'common.actions.more': 'More',
  'common.actions.viewAll': 'View all',
  'common.actions.continue': 'Continue',
  'common.labels.none': '—',
  'common.labels.optional': 'optional',
  'common.labels.search': 'Search',
  'common.labels.loading': 'Loading…',
  'common.state.all': 'All',
  'common.state.pleaseWait': 'Please wait…',
  'common.time.today': 'Today',
  'common.time.yesterday': 'Yesterday',
  'common.time.last7': 'Last 7 days',
  'common.time.older': 'Older',
  'common.units.parseh': 'Parseh',
  'common.units.toman': 'Toman',
  'common.units.tomanShort': 'T',
  'common.units.years': '{{count}} yrs',
  'common.units.kg': 'kg',
  'common.units.cm': 'cm',
  'common.units.second': 's',
  'common.gender.male': 'Male',
  'common.gender.female': 'Female',
  'common.gender.other': 'Other',

  // ── mobile shell ─────────────────────────────────────────────────────
  'mobile.greeting': 'Welcome,',
  'mobile.showMore': 'Show more',
  'mobile.close': 'Close',
  'mobile.menu': 'Menu',

  // ── the practice / teaching disclaimers — core.md §3 ─────────────────
  'practice.badge': 'Practice patient',
  'practice.badge.short': 'Practice',
  'practice.banner.title': 'This is an imaginary patient',
  'practice.banner.body': 'Everything here is a teaching case you invented. Never enter a real person’s details — no name, no national ID, no phone number.',
  'practice.caseRef.label': 'Your own filing label',
  'practice.caseRef.helper': 'Your own label — «Case 12», «CASE-2026-03». It is NOT a national ID and must never be one.',
  'practice.ai.title': 'Educational answer, not clinical advice',
  'practice.ai.body': 'The assistant explains its reasoning so you can study it. It is answering about an imaginary patient and must never be used to treat a real person.',
  'practice.ai.short': 'Educational — not clinical advice.',

  // ── keyboard shortcuts ───────────────────────────────────────────────
  'shortcuts.title': 'Keyboard shortcuts',
  'shortcuts.groups.general': 'General',
  'shortcuts.groups.visit': 'Visit',
  'shortcuts.search': 'Search patients',
  'shortcuts.help': 'This list',
  'shortcuts.close': 'Close the open sheet',
  'shortcuts.empty': 'No shortcuts on this screen.',
  // The static reference the `?` overlay shows OUTSIDE a visit: the bindings
  // only exist while a visit is open, but a student should be able to read them
  // before opening one.
  'shortcuts.groups.insideVisit': 'Inside a visit',

  // ── paging ───────────────────────────────────────────────────────────
  'common.pager.prev': 'Previous',
  'common.pager.next': 'Next',
  'common.pager.page': 'Page {{current}} of {{pages}}',

  // ── connectivity banner — core.md §15 ────────────────────────────────
  'connectivity.offline': 'No internet — changes are not being saved',
  'connectivity.degraded': 'The server cannot be reached — retrying',
  'connectivity.restored': 'Connection is back',
  'connectivity.retry': 'Check again',
  'connectivity.checking': 'Checking…',
};

export default common;
